/**
 * Manually defines field types used on API
 * There is also an API route returning this, but mapping is still needed
 * to connect API field types to Vue components, so it's done manually
 */

export const matchPicker = {
    id: 100,
    name: 'Match Picker',
    component: 'MatchPicker',
    vueComponent: 'MatchPicker',
    valueType: 'string',
    isSystem: false,
    searchable: true,
};

/**
 * Field id to field object map
 *
 * @type  {Object}
 */
export const mapFromIdDependencies = {
    100: matchPicker,
};
